type RightProps = {
  color?: string
}

const Right = ({ color = '#FFFFFF' }: RightProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6488 6.625H11.8543L11.0026 5.77176L6.73617 1.49766C6.59081 1.35204 6.59091 1.11619 6.7364 0.970705C6.88198 0.825123 7.11802 0.825123 7.2636 0.970704L13.0101 6.71719C13.1663 6.87338 13.1663 7.12662 13.0101 7.28281L7.2636 13.0293C7.11802 13.1749 6.88198 13.1749 6.7364 13.0293C6.59091 12.8838 6.59081 12.648 6.73617 12.5023L11.0026 8.22824L11.8543 7.375H10.6488H0.875C0.667893 7.375 0.5 7.20711 0.5 7C0.5 6.79289 0.667893 6.625 0.875001 6.625H10.6488Z"
      fill={color}
      stroke={color}
    />
  </svg>
)

export default Right
